import React from 'react'
import { Link } from 'gatsby'

const data = [
  {
    title: 'Numerical reasoning tests',
    desc: [
      <p>
        These <a href="https://www.jobtestprep.co.uk/opq32#PRT">tests</a>{' '}
        require you to answer questions based on{' '}
        <span>statistics, figures and charts.</span>
      </p>,
    ],
    img: '/numerical.svg',
  },
  {
    title: 'Verbal reasoning tests',
    desc: [
      <p>
        A means of assessing your{' '}
        <span>
          <a href="https://www.jobtestprep.co.uk/opq32#PRT">verbal</a> logic
        </span>{' '}
        and capacity to quickly digest information from passages of text.
      </p>,
    ],
    img: '/verbal.svg',
  },
  {
    title: 'Intray exercises',
    desc: [
      <p>
        A business-related scenario that assesses how well you can{' '}
        <span>prioritise tasks.</span>
      </p>,
    ],
    img: '/intray.svg',
  },
  {
    title: 'Diagrammatic tests ',
    desc: [
      <p>
        <a href="https://www.jobtestprep.co.uk/opq32#PRT">Tests</a> that measure
        your{' '}
        <Link to="/practice-logical-reasoning-test">logical reasoning</Link>,
        usually under <span>strict time conditions.</span>
      </p>,
    ],
    img: '/diargrammatic.svg',
  },
  {
    title: 'Situational judgement tests ',
    desc: [
      <p>
        Psychological{' '}
        <a href="https://www.jobtestprep.co.uk/opq32#PRT">tests</a> that assess
        your judgement in resolving <span>work-based problems.</span>
      </p>,
    ],
    img: '/situational.svg',
  },
  {
    title: 'Inductive reasoning tests ',
    desc: [
      <p>
        <a href="https://www.jobtestprep.co.uk/opq32#PRT">Tests</a> that
        identify how well a candidate can see the{' '}
        <span>underlying logic in patterns,</span> rather than words or numbers.
      </p>,
    ],
    img: '/inductive.svg',
  },
  {
    title: 'Cognitive ability tests ',
    desc: [
      <p>
        A measurement of <span>general intelligence,</span> covering many
        categories of <Link to="/practice-aptitude-tests">aptitude test</Link>.
      </p>,
    ],
    img: '/cognitive.svg',
  },
  {
    title: 'Mechanical reasoning tests ',
    desc: [
      <p>
        These assess your ability to apply{' '}
        <a href="https://www.jobtestprep.co.uk/opq32#PRT">mechanical</a> or
        engineering principles to problems; they are often used for{' '}
        <span>technical roles.</span>
      </p>,
    ],
    img: '/mechanical.svg',
  },
  {
    title: 'Watson Glaser tests ',
    desc: [
      <p>
        Designed to assess a candidate’s ability to critically consider
        arguments; <span>often used by law firms.</span>
      </p>,
    ],
    img: '/watson.svg',
  },
  {
    title: 'Abstract reasoning tests',
    desc: [
      <p>
        Another name for{' '}
        <span>
          <a href="/practice-inductive-test">inductive reasoning tests</a>.
        </span>
      </p>,
    ],
    img: '/abstract.svg',
  },
  {
    title: 'Spatial awareness tests ',
    desc: [
      <p>
        These <a href="https://www.jobtestprep.co.uk/opq32#PRT">tests</a> assess
        your capacity to <span>mentally manipulate images,</span> and are often
        used in applications for jobs in design, engineering and architecture.
      </p>,
    ],
    img: '/spatial.svg',
  },
  {
    title: 'Error checking tests ',
    desc: [
      <p>
        An unusual type of{' '}
        <Link to="/practice-aptitude-tests">aptitude test</Link> that focuses on
        your ability to identify errors in <span>complex data sets.</span>
      </p>,
    ],
    img: '/error-checking.svg',
  },
]

export default data
